import React from "react";
import { Navigate } from "react-router-dom";
import { getAdminToken } from "../../utils/api";

const RequireAdmin = ({ children }) => {
  if (!getAdminToken()) {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};

export default RequireAdmin;
